<template>
    <footer>
        <form class="table">
            <div class="row">
                <router-link :to="{name: 'meine_trends'}" class="col" tag="div" v-on:click.native="setActive('Trends')">
                    <img v-if="active=='Trends'" src="../assets/images/menu/trends_active.svg">
                    <img v-else src="../assets/images/menu/trends.svg">
                    <p :class="active=='Trends'?'active':''">Trends</p>
                </router-link>
                <router-link :to="{name: 'konto'}" class="col" tag="div" v-on:click.native="setActive('Konto')">
                    <img v-if="active=='Konto'" src="../assets/images/menu/konto_active.svg">
                    <img v-else src="../assets/images/menu/konto.svg">
                    <p :class="active=='Konto'?'active':''">Konto</p>
                </router-link>
                <router-link :to="{name: 'konto'}" class="col" tag="div" v-on:click.native="setActive('Deals')">
                    <img v-if="active=='Deals'" src="../assets/images/menu/deals_active.svg">
                    <img v-else src="../assets/images/menu/deals.svg">
                    <p :class="active=='Deals'?'active':''">Deals</p>
                </router-link>
                <router-link :to="{name: 'konto'}" class="col" tag="div" v-on:click.native="setActive('Produkte')">
                    <img v-if="active=='Produkte'" src="../assets/images/menu/produkte_active.svg">
                    <img v-else src="../assets/images/menu/produkte.svg">
                    <p :class="active=='Produkte'?'active':''">Produkte</p>
                </router-link>
                <router-link :to="{name: 'profil'}" class="col" tag="div" v-on:click.native="setActive('Profil')">
                    <img v-if="active=='Profil'" src="../assets/images/menu/profil_active.svg">
                    <img v-else src="../assets/images/menu/profil.svg">
                    <p :class="active=='Profil'?'active':''">Profil</p>
                </router-link>
            </div>
        </form>
    </footer>
</template>

<script>
    export default {
        name: "Footer_menu",
        data() {
            return {
                active: "Trends",
                isA: true
            }
        },
        methods: {
            setActive(activeMenu) {
                this.active = activeMenu;
            }
        }
    }
</script>
<style lang="scss">
    @import '../assets/css/style';
    footer {
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 55px;
        background: white;
        display: table;
        form {
            display: table-cell;
            vertical-align: center;
            text-align: center;
            padding: 0;
            .row {
                height: 20px;
                border-top:1px solid $line_color;
                .col {
                    height: 100vh;
                    width: 100%;

                    img {
                        height: 25px;
                        padding-bottom: 2px;
                    }
                    p {
                        color: #4a4a4a;
                        text-transform: uppercase;
                        margin-top: 3px;
                        font-size: 0.95rem;
                        font-weight: 800;
                    }
                    .active {
                        color: $lila;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer_menu.vue